import { Action } from '../view/types';
import { DateTime } from 'luxon';

export const cashControlFeatureKey = 'cashControl';

export class CashControlModel {
  id: number;
  salesTeamAccountId: number;
  salesTeamAccountName: string;
  controlDate: DateTime;
  realAmount: number;
  calculatedAmount: number;
  differenceAmount: number;
  salesPersonId: number;
  salesPersonName: string;
  description: string;
  creationDate: DateTime;
  actions: Action[];
}
